export default __webpack_public_path__ + "static/media/sun-dried-icon.83902da2.svg";